export default "__VITE_ASSET__1c3c1cca__"